<div class="thumb">
  <img [src]="thumbnail" />
</div>
<ng-content></ng-content>
